import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-1" }
const _hoisted_2 = { class: "!text-sm !font-medium !leading-5 text-foreground" }
const _hoisted_3 = { class: "font-normal" }
const _hoisted_4 = { class: "!text-sm !leading-5 text-muted-foreground" }
const _hoisted_5 = { class: "!text-sm !leading-5 text-muted-foreground" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'review-request-card rounded-xl border bg-card text-card-foreground shadow flex items-center justify-between px-6 py-4',
      _ctx.data.state === 'UPDATED' ? 'cursor-pointer' : '',
    ]),
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToReviewSentRequest && _ctx.goToReviewSentRequest(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, [
        _cache[2] || (_cache[2] = _createTextVNode(" Partner Name: ", -1)),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.data.name), 1)
      ]),
      _createElementVNode("p", _hoisted_4, " Request Sent: " + _toDisplayString(_ctx.formatDate(_ctx.data.created_at)), 1),
      _createElementVNode("p", _hoisted_5, " Partner Response: " + _toDisplayString(_ctx.data.response_at ? _ctx.formatDate(_ctx.data.response_at) : '-'), 1)
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "review-action-btn inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium transition-colors h-8 px-3 !text-xs",
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goToReviewSentRequest && _ctx.goToReviewSentRequest(...args)), ["stop"]))
    }, " Action Required ")
  ], 2))
}